module.exports = __webpack_public_path__ + "img/Ellipse 88.d7390d5f.png";